    import React, {Component, Fragment} from 'react';
import Toolbar from "./Toolbar/Toolbar";
import SideDrawer from "./SideDrawer/SideDrawer";
import Backdrop from "./Backdrop/Backdrop";

class Navbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sideDrawerOpen: false,
            isStiky:true,
        };
    }
    drawerToggleClickHandler = () => {
        this.setState(prevState => {
            return { sideDrawerOpen: !prevState.sideDrawerOpen };
        });
    };

    backdropClickHandler = () => {
        this.setState({ sideDrawerOpen: false });
    };

    render() {
        let backdrop;

        if (this.state.sideDrawerOpen) {
            backdrop = <Backdrop click={this.backdropClickHandler} />;
        }


        return (
           <Fragment>
               <Toolbar drawerClickHandler={this.drawerToggleClickHandler} scenario={this.props.scenario}   isToggle={this.state.sideDrawerOpen}   />
               <SideDrawer show={this.state.sideDrawerOpen}  />
               {backdrop}
           </Fragment>
        );
    }
}

export default Navbar;